import React from 'react';

export interface SliderProps {
  value: number;
  onChange?: (value: number) => void;
  min?: number;
  max?: number;
  suffix?: string;
}

export function Slider({ value, onChange, min = 0, max = 100, suffix = '' }: SliderProps) {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className="flex items-center gap-3.5">
      <div className="relative h-1.5 flex-1">
        <div className="absolute inset-0 rounded-full bg-[var(--cream-2)]" />
        <div
          className="absolute left-0 top-0 h-1.5 rounded-full"
          style={{ width: `${String(pct)}%`, background: 'var(--grad-spectrum)' }}
        />
        <input type="range" min={min} max={max} value={value} onChange={(event) => onChange?.(Number(event.target.value))} className="absolute inset-0 h-1.5 w-full cursor-pointer opacity-0" />
        <span className="pointer-events-none absolute top-1/2 h-[18px] w-[18px] rounded-full border-2 border-[var(--ai-3)] bg-white shadow-[0_2px_5px_rgba(0,0,0,0.2)]" style={{ left: `${String(pct)}%`, transform: 'translate(-50%,-50%)' }} />
      </div>
      <span className="w-11 text-right font-[var(--font-mono)] text-xs text-[var(--ink-1)]">{value}{suffix}</span>
    </div>
  );
}
